import { render } from "./TextField.vue?vue&type=template&id=5fb04be5&scoped=true"
import script from "./TextField.vue?vue&type=script&lang=js"
export * from "./TextField.vue?vue&type=script&lang=js"

import "./TextField.vue?vue&type=style&index=0&id=5fb04be5&lang=scss&scoped=true"

import exportComponent from "/var/www/fgg-staff/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fb04be5"]])

export default __exports__